<template>
    <v-card text>
        <v-toolbar dark dense text color="secondary">
            <v-toolbar-title class="text-body-2">{{ $t('Löschen bestätigen') }}</v-toolbar-title>
        </v-toolbar>
        <v-container grid-list-md>
            <v-layout wrap>
                <v-flex xs12>
                    <span>{{ computedText }}</span>
                    <span class="px-2">:</span>
                    <span class="primary--text">{{ value.name }}</span>
                </v-flex>
                <v-flex xs12>
                    <v-checkbox
                        v-model="confirmDelete"
                        :label="$t('Bestätigen')"
                        :hint="$t('Wenn Sie bereits gelöschte Daten wieder herstellen möchten, wenden Sie sich bitte an den Support.')"
                        persistent-hint
                    />
                </v-flex>
            </v-layout>
        </v-container>
        <v-card-actions>
            <v-btn block color="error" :disabled="!confirmDelete" @click="submit">
                {{ $t('Löschen') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import AuthoringToolMixin from '../Mixins/AuthoringtoolMixin';

export default {
    name: 'catalog-delete-confirm',
    mixins: [AuthoringToolMixin],
    data: () => ({
        confirmDelete: false
    }),
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        onSubmit: {
            type: Function,
            default: () => ({})
        }
    },
    computed: {
        computedText() {
            const type = this.isAuthoringToolType(this.value);
            switch (type) {
                case 'CATALOG':
                    return this.$t('Sind Sie sicher, dass Sie den folgenden Katalog löschen wollen');
                case 'CATALOG_SUBGROUP':
                    return this.$t('Sind Sie sicher, dass Sie die folgende Kataloguntergruppe löschen wollen');
                case 'CATALOG_GROUP':
                    return this.$t('Sind Sie sicher, dass Sie die folgende Kataloggruppe löschen wollen');
            }
            return '';
        }
    },
    methods: {
        submit() {
            this.onSubmit()(this.value);
        }
    },
    deactivated() {
        this.confirmDelete = false;
    }
};
</script>
